/**
 * Swiper Tiles — Mobile carousel for .cm-tiles-grid
 * Only initialises on viewports ≤ 768 px.
 */

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const MOBILE_BREAKPOINT = 768;
let activeSwiper = null;

function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
}

function initSwiper() {
    if (activeSwiper || !isMobile()) return;

    const containers = document.querySelectorAll('.cm-tiles-swiper');
    if (!containers.length) return;

    containers.forEach(container => {
        const swiper = new Swiper(container, {
            slidesPerView: 1,
            spaceBetween: 12,
            loop: true,
            navigation: {
                nextEl: container.querySelector('.cm-swiper-next'),
                prevEl: container.querySelector('.cm-swiper-prev'),
            },
            pagination: {
                el: container.querySelector('.swiper-pagination'),
                clickable: true,
            },
        });

        // Remove Swiper's inline grid/flex styles so our CSS takes over
        const wrapper = container.querySelector('.swiper-wrapper');
        if (wrapper) {
            wrapper.style.removeProperty('grid-template-columns');
            wrapper.style.removeProperty('display');
            wrapper.style.removeProperty('gap');
            wrapper.style.removeProperty('flex-direction');
        }

        container.querySelectorAll('.swiper-slide').forEach(slide => {
            slide.style.removeProperty('width');
            slide.style.removeProperty('margin-right');
            slide.style.removeProperty('height');
        });

        activeSwiper = swiper;
        swiper.update();
    });
}

function destroySwiper() {
    if (!activeSwiper) return;

    const containers = document.querySelectorAll('.cm-tiles-swiper');
    containers.forEach(container => {
        if (container.swiper) {
            container.swiper.destroy(true, true);
        }
    });

    activeSwiper = null;
}

let resizeTimer;
function handleResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
        if (isMobile() && !activeSwiper) {
            initSwiper();
        } else if (!isMobile() && activeSwiper) {
            destroySwiper();
        }
    }, 250);
}

function init() {
    document.addEventListener('DOMContentLoaded', () => {
        initSwiper();
        window.addEventListener('resize', handleResize);
    });
}

init();
